export const getCarName = (carDetail) => {
    return carDetail?.make + ' ' + carDetail?.model + ' ' + carDetail?.trim;
}